import * as React from 'react';
export const bellcoSvg = React.forwardRef(function bellcoSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#172B54',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M8 6v.092c5.978.689 10.037 2.47 10.477 4.784.414 2.195-3.966 4.61-10.477 4.931v6.281c5.785-.12 9.789-1.892 10.689-3.857.652-1.423-.395-2.709-2.287-3.774a8.88 8.88 0 0 0 .983-.578c2.387 1.203 3.948 2.736 4.224 4.39.514 3.176-5.115 6.73-13.609 7.648V26h16.18V6H8Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M16.43 10.82c1-2.093-4.087-3.828-8.43-4.407v4.895c2.13.257 4.105.697 5.895 1.23 1.332-.44 2.223-1.056 2.535-1.717Zm-3.894 2.067A36.21 36.21 0 0 0 8 11.859v1.35c1.736.064 3.27-.065 4.536-.331',
      fill: '#fff',
    }),
  );
});
bellcoSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var bellco = {
  category: 'brand',
  colorable: false,
  name: 'bellco',
  svg: bellcoSvg,
};
